module.exports = __webpack_public_path__ + "static/img/sanLogo.da50cd71.png";